import React, { createContext, useContext, useEffect } from 'react';
import useMutableValue, { mutableValuePlaceholder, } from '@polestar/component-warehouse-react/hooks/useMutableValue';
const PopoverContext = createContext({
    openPopovers: mutableValuePlaceholder([]),
});
export const usePopover = (id) => {
    // Keep track of which popovers are open to determine if popover blocks for example Drawer behaviour
    const { openPopovers } = useContext(PopoverContext);
    useEffect(() => {
        // add popover as AttachedPopover has called it
        if (id) {
            const popovers = openPopovers.get();
            popovers.push(id);
            openPopovers.set(popovers);
        }
        return () => {
            // remove while not open anymore
            openPopovers.set(openPopovers.get().filter((val) => val !== id));
        };
    }, [id, openPopovers]);
    // return list of current popovers to listen in when popovers are open
    return { openPopovers };
};
/**
 * @internal
 */
export const PopoverProvider = ({ children }) => {
    const openPopovers = useMutableValue([]);
    return (React.createElement(PopoverContext.Provider, { value: {
            openPopovers,
        } }, children));
};
